var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoticiasArgentinas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 1254.0332,
    height: 140.03505,
    viewBox: "0 0 1254.0332 140.03505",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1080 H 1080 V 0 H 0 Z",
    id: "path14"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,-94.684236,793.06385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(105.1777,492.9922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -17.641,6.56 -29.504,21.837 -32.525,39.13 5.667,-10.574 15.07,-19.21 27.2,-23.722 C 21.117,5.572 50.53,19.036 60.364,45.479 63.64,54.284 64.328,63.412 62.82,72.04 69.512,59.566 71.017,44.384 65.691,30.071 55.859,3.626 26.447,-9.84 0,0",
    style: {
      fill: "#024487",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(148.4565,522.1699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -11.777,-9.305 -27.096,-11.063 -40.131,-5.96 9.556,-0.517 19.328,2.313 27.427,8.709 17.646,13.948 20.652,39.559 6.708,57.21 -4.643,5.873 -10.577,10.124 -17.081,12.669 C -11.805,72.02 -0.84,66.761 6.71,57.21 20.652,39.56 17.65,13.945 0,0",
    style: {
      fill: "#aeadb3",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(145.2856,559.5371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.654,-12.369 -5.465,-23.527 -15.118,-29.873 4.903,6.186 7.658,14.121 7.209,22.627 -0.977,18.534 -16.796,32.768 -35.335,31.793 -6.17,-0.326 -11.862,-2.3 -16.677,-5.463 5.782,7.305 14.555,12.182 24.588,12.71 C -16.794,32.77 -0.978,18.533 0,0",
    style: {
      fill: "#024487",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(117.8945,574.0117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 9.402,-6.077 14.329,-16.474 13.862,-26.907 -1.933,6.873 -6.28,13.093 -12.746,17.274 -14.094,9.109 -32.901,5.072 -42.016,-9.021 -3.03,-4.687 -4.606,-9.9 -4.836,-15.106 -2.283,8.105 -1.208,17.115 3.721,24.743 C -32.901,5.076 -14.09,9.114 0,0",
    style: {
      fill: "#dc0009",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(321.6454,532.959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 12.118,27.954 24.1,0 Z M 22.446,56.598 H 1.653 l -33.051,-76.5 v 76.5 H -52.883 V -5.369 l -47.232,61.967 h -20.104 v -96.256 h 21.479 v 60.313 l 45.857,-60.313 h 35.808 l 8.951,20.794 h 40.347 l 8.953,-20.794 h 22.86 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(489.0707,589.6411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 9.043 V -40.52 H 0 l -19.302,25.39 v -25.39 h -9.043 V 0 h 8.462 L 0,-26.086 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(539.3871,569.6123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,3.615 -1.159,6.697 -3.479,9.247 -2.317,2.549 -5.168,3.826 -8.55,3.826 -3.382,0 -6.232,-1.277 -8.55,-3.826 -2.319,-2.55 -3.478,-5.632 -3.478,-9.247 0,-3.614 1.159,-6.684 3.478,-9.217 2.318,-2.531 5.168,-3.798 8.55,-3.798 3.382,0 6.233,1.267 8.55,3.798 C -1.159,-6.684 0,-3.614 0,0 m 3.074,-14.898 c -4.098,-3.998 -9.141,-5.999 -15.132,-5.999 -5.989,0 -11.034,2.001 -15.129,5.999 -4.097,4.002 -6.145,8.975 -6.145,14.927 0,5.952 2.048,10.927 6.145,14.928 4.095,3.999 9.14,6.001 15.129,6.001 5.991,0 11.034,-2.002 15.132,-6.001 4.093,-4.001 6.142,-8.976 6.142,-14.928 0,-5.952 -2.049,-10.925 -6.142,-14.927",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(572.6024,581.8159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -32.695 H -9.042 V 0 H -20.52 V 7.825 H 11.478 V 0 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 590.977,589.642 h 9.044 v -40.521 h -9.044 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(628.8876,557.1221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.444,0 8.077,1.755 10.898,5.275 l 5.797,-5.972 c -4.6,-5.179 -10.018,-7.768 -16.26,-7.768 -6.24,0 -11.381,1.97 -15.418,5.914 -4.04,3.94 -6.058,8.916 -6.058,14.926 0,6.01 2.057,11.024 6.172,15.043 4.116,4.019 9.149,6.03 15.101,6.03 6.648,0 12.213,-2.533 16.696,-7.594 L 11.307,19.475 C 8.444,23.03 4.89,24.81 0.639,24.81 c -3.401,0 -6.309,-1.113 -8.723,-3.333 -2.417,-2.225 -3.624,-5.216 -3.624,-8.986 0,-3.768 1.139,-6.793 3.42,-9.072 C -6.008,1.138 -3.246,0 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 653.004,589.642 h 9.042 v -40.521 h -9.042 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(688.9434,577.584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -5.102,-11.768 H 5.042 Z m 12.23,-28.462 -3.765,8.751 H -8.523 l -3.767,-8.751 h -9.622 l 17.506,40.519 h 8.755 l 17.505,-40.519 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(724.9716,581.5552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.869,-0.716 -1.306,-1.661 -1.306,-2.841 0,-1.179 0.533,-2.116 1.597,-2.812 1.061,-0.694 3.514,-1.517 7.36,-2.465 3.846,-0.946 6.83,-2.364 8.956,-4.258 2.125,-1.896 3.19,-4.66 3.19,-8.29 0,-3.634 -1.363,-6.579 -4.088,-8.84 -2.723,-2.263 -6.31,-3.391 -10.754,-3.391 -6.414,0 -12.192,2.376 -17.332,7.129 l 5.392,6.61 c 4.365,-3.827 8.405,-5.739 12.114,-5.739 1.663,0 2.968,0.356 3.913,1.071 0.947,0.715 1.422,1.682 1.422,2.9 0,1.214 -0.504,2.183 -1.508,2.896 -1.006,0.715 -2.997,1.44 -5.972,2.176 -4.715,1.119 -8.163,2.578 -10.346,4.377 -2.184,1.794 -3.277,4.614 -3.277,8.462 0,3.844 1.381,6.81 4.146,8.898 2.764,2.087 6.211,3.131 10.349,3.131 2.703,0 5.409,-0.464 8.114,-1.393 2.706,-0.926 5.063,-2.24 7.073,-3.938 L 14.462,-2.928 C 10.946,-0.261 7.314,1.071 3.564,1.071 2.057,1.071 0.869,0.714 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(477.3612,523.6016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -5.101,-11.767 H 5.042 Z m 12.231,-28.462 -3.768,8.753 H -8.521 l -3.768,-8.753 h -9.623 l 17.506,40.521 h 8.753 l 17.507,-40.521 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(526.1708,517.4004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 1.121,1.004 1.681,2.598 1.681,4.781 0,2.184 -0.58,3.68 -1.739,4.493 -1.161,0.813 -3.189,1.217 -6.086,1.217 h -6.784 v -12 h 6.609 c 3.092,0 5.197,0.502 6.319,1.509 m 10.897,4.81 c 0,-6.493 -2.568,-10.686 -7.709,-12.577 L 13.449,-22.261 H 2.319 l -8.986,12.93 h -6.261 v -12.93 H -21.97 V 18.26 h 15.361 c 6.298,0 10.792,-1.063 13.477,-3.191 2.687,-2.125 4.029,-5.543 4.029,-10.259",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74",
    transform: "translate(572.9501,515.7773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 9.103 v -14.377 c -4.02,-4.483 -9.585,-6.725 -16.696,-6.725 -5.952,0 -10.949,1.97 -14.986,5.915 -4.037,3.941 -6.058,8.917 -6.058,14.924 0,6.009 2.06,11.023 6.175,15.043 4.116,4.021 9.081,6.031 14.897,6.031 5.814,0 10.87,-1.914 15.16,-5.742 L 2.898,8.29 c -1.816,1.584 -3.489,2.676 -5.013,3.275 -1.529,0.598 -3.179,0.897 -4.956,0.897 -3.44,0 -6.339,-1.168 -8.697,-3.506 -2.358,-2.341 -3.535,-5.421 -3.535,-9.245 0,-3.827 1.131,-6.893 3.391,-9.189 2.26,-2.299 4.955,-3.45 8.087,-3.45 3.132,0 5.739,0.598 7.825,1.797 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g78",
    transform: "translate(619.6161,535.6602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -8.061 h -20.173 v -8.345 H -2.03 v -7.708 H -20.173 V -32.52 H 0.639 v -8.001 H -29.219 V 0 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(656.9462,535.6602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 9.044 V -40.521 H 0 l -19.303,25.392 v -25.392 h -9.042 V 0 h 8.461 L 0,-26.088 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(693.4091,527.835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -32.695 H -9.044 V 0 h -11.477 v 7.825 h 32 V 0 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 711.784,535.66 h 9.042 v -40.521 h -9.042 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g92",
    transform: "translate(759.4326,535.6602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 9.044 V -40.521 H 0 l -19.304,25.392 v -25.392 h -9.041 V 0 h 8.461 L 0,-26.088 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96",
    transform: "translate(795.374,523.6016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -5.103,-11.767 H 5.042 Z m 12.232,-28.462 -3.768,8.753 H -8.521 l -3.769,-8.753 h -9.623 l 17.509,40.521 h 8.753 l 17.505,-40.521 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100",
    transform: "translate(831.4022,527.5732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.869,-0.715 -1.306,-1.66 -1.306,-2.84 0,-1.181 0.532,-2.116 1.595,-2.813 1.063,-0.694 3.516,-1.516 7.361,-2.463 3.845,-0.948 6.832,-2.365 8.958,-4.258 2.125,-1.897 3.187,-4.662 3.187,-8.29 0,-3.636 -1.361,-6.581 -4.087,-8.842 -2.725,-2.261 -6.308,-3.39 -10.753,-3.39 -6.415,0 -12.192,2.375 -17.334,7.129 l 5.391,6.609 c 4.368,-3.827 8.408,-5.739 12.117,-5.739 1.662,0 2.965,0.357 3.912,1.072 0.948,0.715 1.421,1.682 1.421,2.898 0,1.217 -0.502,2.185 -1.509,2.897 -1.004,0.715 -2.994,1.439 -5.969,2.177 -4.715,1.119 -8.165,2.578 -10.346,4.378 -2.185,1.794 -3.277,4.615 -3.277,8.461 0,3.844 1.381,6.809 4.146,8.897 2.762,2.087 6.211,3.132 10.347,3.132 2.705,0 5.411,-0.465 8.116,-1.393 2.705,-0.926 5.063,-2.238 7.071,-3.939 L 14.462,-2.926 C 10.944,-0.26 7.312,1.072 3.565,1.072 2.057,1.072 0.869,0.715 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(858.9365,496.1533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.987,0.986 -1.479,2.193 -1.479,3.626 0,1.425 0.492,2.635 1.479,3.621 0.984,0.985 2.191,1.477 3.621,1.477 1.43,0 2.64,-0.492 3.626,-1.477 C 8.232,6.261 8.724,5.051 8.724,3.626 8.724,2.193 8.232,0.986 7.247,0 6.261,-0.984 5.051,-1.478 3.621,-1.478 2.191,-1.478 0.984,-0.984 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g108",
    transform: "translate(894.788,503.1406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.443,0 8.074,1.756 10.899,5.274 l 5.796,-5.971 c -4.6,-5.179 -10.018,-7.769 -16.26,-7.769 -6.241,0 -11.382,1.971 -15.419,5.915 -4.037,3.942 -6.058,8.917 -6.058,14.925 0,6.011 2.057,11.025 6.173,15.043 4.115,4.021 9.149,6.03 15.101,6.03 6.648,0 12.212,-2.531 16.696,-7.592 l -5.624,-6.38 c -2.86,3.557 -6.414,5.336 -10.665,5.336 -3.401,0 -6.31,-1.113 -8.724,-3.333 -2.416,-2.226 -3.623,-5.218 -3.623,-8.986 0,-3.768 1.136,-6.792 3.42,-9.074 C -6.009,1.139 -3.247,0 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g112",
    transform: "translate(949.0488,515.6299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,3.616 -1.161,6.699 -3.48,9.247 -2.318,2.549 -5.168,3.827 -8.549,3.827 -3.384,0 -6.231,-1.278 -8.552,-3.827 -2.316,-2.548 -3.477,-5.631 -3.477,-9.247 0,-3.614 1.161,-6.684 3.477,-9.216 2.321,-2.531 5.168,-3.797 8.552,-3.797 3.381,0 6.231,1.266 8.549,3.797 C -1.161,-6.684 0,-3.614 0,0 m 3.07,-14.898 c -4.096,-3.996 -9.14,-5.998 -15.129,-5.998 -5.991,0 -11.035,2.002 -15.13,5.998 -4.096,4.003 -6.143,8.978 -6.143,14.927 0,5.952 2.047,10.93 6.143,14.928 4.095,4.001 9.139,6.001 15.13,6.001 5.989,0 11.033,-2 15.129,-6.001 C 7.166,10.959 9.215,5.981 9.215,0.029 9.215,-5.92 7.166,-10.895 3.07,-14.898",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g116",
    transform: "translate(1002.4941,520.6465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -10.957,-22.143 h -5.389 L -27.246,0 v -25.507 h -9.041 v 40.523 h 12.231 l 10.433,-22.26 10.494,22.26 H 9.044 V -25.507 H 0 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 423.104,493.502 h -4.828 v 95.473 h 4.828 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoticiasArgentinas);
export default __webpack_public_path__ + "static/media/logo_noticias_argentinas.04ca4d94f9db35bbf929f87093f85de7.svg";
export { ForwardRef as ReactComponent };